(() => {
  const gate = document.querySelector('[data-ghosty-age-gate]');
  if (!gate) return;

  const COOKIE_NAME = 'ghosty_age_verified';
  const VERIFIED_VALUE = '1';
  const body = document.body;
  const root = document.documentElement;
  const pageWrapper = document.querySelector('.page-wrapper');
  const acceptButton = gate.querySelector('[data-ghosty-age-accept]');
  const denyButton = gate.querySelector('[data-ghosty-age-deny]');
  const status = gate.querySelector('[data-ghosty-age-status]');
  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'textarea:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  let previousFocus = null;
  let isShown = false;

  const getRememberDays = () => {
    const value = parseInt(gate.dataset.rememberDays || '30', 10);
    return Number.isFinite(value) && value > 0 ? value : 30;
  };

  const getCookie = (name) => {
    const encodedName = `${encodeURIComponent(name)}=`;
    return document.cookie
      .split(';')
      .map((part) => part.trim())
      .find((part) => part.startsWith(encodedName))
      ?.slice(encodedName.length) || '';
  };

  const hasVerifiedCookie = () => getCookie(COOKIE_NAME) === VERIFIED_VALUE;

  const markVerifiedState = () => {
    root.classList.remove('ghosty-age-gate-needs-verification');
    root.classList.add('ghosty-age-gate-preverified');
  };

  const markNeedsVerificationState = () => {
    root.classList.remove('ghosty-age-gate-preverified');
    root.classList.add('ghosty-age-gate-needs-verification');
  };

  const getSharedCookieDomain = () => {
    const configuredDomain = (gate.dataset.cookieDomain || '').trim();
    const hostname = window.location.hostname.toLowerCase();

    if (configuredDomain) {
      const normalized = configuredDomain.replace(/^\./, '').toLowerCase();
      if (hostname === normalized || hostname.endsWith(`.${normalized}`)) {
        return `.${normalized}`;
      }
    }

    if (hostname === 'ghostydabs.com' || hostname.endsWith('.ghostydabs.com')) {
      return '.ghostydabs.com';
    }

    return '';
  };

  const writeCookie = (domain = '') => {
    const maxAge = getRememberDays() * 24 * 60 * 60;
    const parts = [
      `${encodeURIComponent(COOKIE_NAME)}=${VERIFIED_VALUE}`,
      `Max-Age=${maxAge}`,
      'Path=/',
      'SameSite=Lax'
    ];

    if (window.location.protocol === 'https:') {
      parts.push('Secure');
    }

    if (domain) {
      parts.push(`Domain=${domain}`);
    }

    document.cookie = parts.join('; ');
  };

  const setVerifiedCookie = () => {
    const sharedDomain = getSharedCookieDomain();

    if (sharedDomain) {
      writeCookie(sharedDomain);
    }

    // Fallback for Shopify preview domains, myshopify.com, local previews, or strict DNS situations.
    if (!hasVerifiedCookie()) {
      writeCookie('');
    }
  };

  const setPageInert = (enabled) => {
    if (!pageWrapper) return;

    if (enabled) {
      pageWrapper.setAttribute('inert', '');
      pageWrapper.setAttribute('aria-hidden', 'true');
    } else {
      pageWrapper.removeAttribute('inert');
      pageWrapper.removeAttribute('aria-hidden');
    }
  };

  const getFocusableElements = () => Array.from(gate.querySelectorAll(focusableSelector))
    .filter((element) => element.offsetParent !== null || element === document.activeElement);

  const showGate = () => {
    markNeedsVerificationState();

    if (isShown) return;

    previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    gate.hidden = false;
    gate.classList.remove('is-hiding');
    gate.setAttribute('aria-hidden', 'false');
    body.classList.add('ghosty-age-gate-lock');
    setPageInert(true);
    isShown = true;

    window.requestAnimationFrame(() => {
      acceptButton?.focus({ preventScroll: true });
    });
  };

  const hideGate = (instant = false) => {
    if (!isShown && gate.hidden) return;

    const complete = () => {
      gate.hidden = true;
      gate.setAttribute('aria-hidden', 'true');
      body.classList.remove('ghosty-age-gate-lock');
      setPageInert(false);
      isShown = false;

      if (hasVerifiedCookie()) {
        markVerifiedState();
      }

      if (previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus({ preventScroll: true });
      }
    };

    if (instant) {
      complete();
      return;
    }

    gate.classList.add('is-hiding');
    window.setTimeout(complete, 200);
  };

  const acceptAge = () => {
    setVerifiedCookie();
    markVerifiedState();
    hideGate();
  };

  const denyAge = () => {
    const minimumAge = gate.dataset.minAge || '18';
    const denyUrl = (gate.dataset.denyUrl || '').trim();

    if (status) {
      status.textContent = `You must be ${minimumAge} or older to access this site.`;
    }

    denyButton?.setAttribute('disabled', 'disabled');
    acceptButton?.setAttribute('disabled', 'disabled');

    if (denyUrl) {
      window.setTimeout(() => {
        window.location.assign(denyUrl);
      }, 900);
    }
  };

  const trapFocus = (event) => {
    if (!isShown || event.key !== 'Tab') return;

    const focusable = getFocusableElements();
    if (!focusable.length) {
      event.preventDefault();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  acceptButton?.addEventListener('click', acceptAge);
  denyButton?.addEventListener('click', denyAge);
  document.addEventListener('keydown', trapFocus);

  window.addEventListener('pageshow', () => {
    if (hasVerifiedCookie()) {
      hideGate(true);
    } else {
      showGate();
    }
  });

  if (hasVerifiedCookie()) {
    hideGate(true);
  } else {
    showGate();
  }
})();
